const scrollToBottomOfTextField = (id: string): void => {
    // Select the textarea within the MUI TextField component
    const textField = document.querySelector(`#${id}`);

    if (textField) {
        // setTimeout as a "hack" to ensure that the text field scrolls to the bottom after the text is updated
        setTimeout(() => {
            // Scroll to the bottom
            textField.scrollTop = textField.scrollHeight;
        }, 50);
    }
};

export { scrollToBottomOfTextField };
